'use strict';

var ChartFBCUsageDirective = function ChartFBCUsageDirective() {
  return {
    template: require('../templates/chart-fbc-usage.html'),
    controller: 'ChartFBCUsageController',
    replace: true,
    scope: {
      filterData: '=',
      marketTagKey: '='
    },
    link: function link($scope) {
      $scope.$watch('filterData', function () {
        var classUsageFilter = $scope.filterData['class-usage'];
        $scope.retrieveData(classUsageFilter);
      }, true);
    }
  };
};
ChartFBCUsageDirective.$inject = ['$filter', 'ChartFBCFactory'];
module.exports = ChartFBCUsageDirective;